const chatElements = {
  baseUrl: window.location.origin,
  chatContainer: document.getElementById("chat-container"),
  initialBox: document.getElementById('initial-box'),
  chatToggle: document.getElementById('chat-toggle'),
  chatClose: document.getElementById('chatClose'),
  chatToggleButtons: document.querySelectorAll('.chat-toggle-button'),
  chatBody: document.getElementById('chat-body'),
  chatInput: document.getElementById('chatInput'),
  chatSend: document.getElementById('chat-send'),
  restartChat: document.getElementById('restartChat'),
};

chatElements.programAcronym = chatElements.chatContainer?.dataset?.acronym || '';
chatElements.programName = chatElements.chatContainer?.dataset?.program || '';
chatElements.sourceAccount = chatElements.chatContainer?.dataset?.account || '';
chatElements.formID = chatElements.chatContainer?.dataset?.formid || '';

export default chatElements;